import styles from "./Labels.module.css";

const ProjectLabel = () => {
  return (
    <div className={styles.projectLabel}>
      <p className={styles.textCol1}>COLL</p>
      <p className={styles.flickerText} data-heading="E"></p>
      <p className={styles.textCol2}>CTOR</p>
    </div>
  );
};

export default ProjectLabel;
